var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckMonster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5C13 4.44772 13.4477 4 14 4H18.323C18.7319 4 19.0996 4.24895 19.2514 4.62861L21 9C21.5523 9 22 9.44772 22 10V14C22 14.1691 21.958 14.3285 21.8839 14.4681C20.9678 12.7046 19.1246 11.5 17 11.5C14.7814 11.5 12.8696 12.8136 12 14.7055C11.1304 12.8136 9.2186 11.5 7 11.5C4.87543 11.5 3.03221 12.7046 2.11612 14.4681C2.04199 14.3285 2 14.1691 2 14V10C2 9.44772 2.44772 9 3 9H3.25C3.25 6.92893 4.92893 5.25 7 5.25H13V5ZM13 6.75H7C5.75736 6.75 4.75 7.75736 4.75 9H13V6.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C18.4806 13 19.7733 13.8044 20.4649 15C20.8052 15.5883 21 16.2714 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 16.2714 13.1948 15.5883 13.5351 15C14.2267 13.8044 15.5194 13 17 13ZM15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4649 15C9.77325 13.8044 8.48057 13 7 13C5.51944 13 4.22675 13.8044 3.53513 15C3.19479 15.5883 3 16.2714 3 17C3 19.2091 4.79086 21 7 21C9.20914 21 11 19.2091 11 17C11 16.2714 10.8052 15.5883 10.4649 15ZM7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckMonster);
export default __webpack_public_path__ + "static/media/truck-monster.8c23f1be39e5d32e3c8862caa8657f8c.svg";
export { ForwardRef as ReactComponent };